import {Animation} from 'animation';
import { createButton } from './common/ui';
import screen from '../cfg/screen-config.js'

import {UiMenu} from "./library/minigame_client/ui/menu";
import {UiPanel} from "./library/minigame_client/ui/panel";

import SETTINGS from 'settings'

export default class UiScene extends PIXI.Container
{
    constructor(configGame, configMenu, configPanel) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const config = configGame.UiScene;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");
        const snd = this.sndBtnClick;

        this.buttonMore = createButton(this, config.buttonMore.pos.x, config.buttonMore.pos.y, packFolder + "more", snd);
        this.buttonStop = createButton(this, config.buttonStop.pos.x, config.buttonStop.pos.y, packFolder + "stop", snd);


        let createLabel = function(pos, font, achor = {x: 0.5, y: 0.5}) {
            let label = new PIXI.extras.BitmapText("", {font: font, align: "center"});
            label.position.set(pos.x, pos.y);
            label.anchor.set(achor.x, achor.y);
            self.addChild(label);

            return label;
        };

        let lblCfg = config.labelDealerPoints;
        this.labelDealerPoints = createLabel({x: lblCfg.pos.x, y: lblCfg.pos.y}, lblCfg.font.name);

        lblCfg = config.labelPlayerPoints;
        this.labelPlayerPoints = createLabel({x: lblCfg.pos.x, y: lblCfg.pos.y}, lblCfg.font.name);

        lblCfg = config.labelScoreWin;
        this.labelScoreWin = createLabel({x: lblCfg.pos.x, y: lblCfg.pos.y}, lblCfg.font.name);

        lblCfg = config.labelScoreForward;
        this.labelScoreForward = createLabel({x: lblCfg.pos.x, y: lblCfg.pos.y}, lblCfg.font.name);

        lblCfg = config.labelScoreLose;
        this.labelScoreLose = createLabel({x: lblCfg.pos.x, y: lblCfg.pos.y}, lblCfg.font.name);

        this.uiMenu = new UiMenu(configMenu);
        this.addChild(this.uiMenu);

        this.uiPanel = new UiPanel(configPanel);
        this.addChild(this.uiPanel);

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container && !this.isDesktopHorizontal) {
            this.removeChild(this.buttonMore);
            this.removeChild(this.buttonStop);
            this.removeChild(this.uiMenu);
            this.removeChild(this.uiPanel);

            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.buttonMore);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.buttonStop);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.uiMenu);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.uiPanel);
        }
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container)
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.removeChildren();

        this.buttonMore = null;
        this.buttonStop = null;

        this.labelDealerPoints = null;
        this.labelPlayerPoints = null;
        this.labelScoreWin = null;
        this.labelScoreForward = null;
        this.labelScoreLose = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;

        this.uiMenu.terminate();
        this.uiMenu = null;

        this.uiPanel.terminate();
        this.uiPanel = null;
    }

    addLobbyButtonToNewParrent (newParent) {
        this.uiMenu.addLobbyButtonToNewParrent(newParent);
    }

    resetLobbyButtonParrent () {
        this.uiMenu.addLobbyButtonToNewParrent(this.uiMenu);
    }

    setLock(isLock, state) {

        let self = this;

        this.uiMenu.lockSettingsButton();
        this._lockButton(this.buttonMore, true);
        this._lockButton(this.buttonStop, true);

        switch( state ) {

            case "PREPARE": {
                if (!isLock) {
                    this.uiMenu.unlockSettingsButton();
                    this.setAutoPlayButtonEnable(!this.isLockPlaceBetButton());
                }
            }
                break;

            case "GAME": {
                this._lockButton(this.buttonMore, isLock);
                this._lockButton(this.buttonStop, isLock);
            }
                break;
            default: break;
        }
    }

    isLockPlaceBetButton () {
        return this.uiPanel.isLockPlaceBetButton();
    }

    isLockMoreButton () {
        return !this.buttonMore.enabled;
    }


    getTotalBet () {
        return this.uiPanel.getTotalBet();
    }

    setCurrency (currency) {
        this.uiPanel.setCurrency(currency);
    }

    setLabelCredits (credits, precision, delimiter) {
        this.uiPanel.setLabelCredits(credits, precision, delimiter);
    }

    setModelBet (bet, isInitState) {
        this.uiPanel.setModelBet(bet, isInitState);
        // if (isInitState)
        //     this._tryUnlockPlaceBet();
    }

    setLabelDealerPointsText (strPoints) {
        this.labelDealerPoints.text = strPoints;
    }

    setLabelPlayerPointsText (strPoints) {
        this.labelPlayerPoints.text = strPoints;
    }

    setLabelScoreWinText (strCountWins) {
        this.labelScoreWin.text = strCountWins;
    }

    setLabelScoreForwardText (strCountWins) {
        this.labelScoreForward.text = strCountWins;
    }

    setLabelScoreLoseText (strCountWins) {
        this.labelScoreLose.text = strCountWins;
    }




    setOnButtonMoreEvent (func) {
        this.buttonMore.callback = function() {func();};
    }

    setOnButtonStopEvent (func) {
        this.buttonStop.callback = function() {func();};
    }

    setOnButtonPlaceBetEvent (func) {
        this.uiPanel.setOnPlaceBet(func);
    }

    setOnButtonSettingsEvent (func) {
        this.uiMenu.setOnButtonSettingsEvent(func);
    }

    setOnButtonHelpEvent (func) {
        this.uiMenu.setOnButtonHelpEvent(func);
    }

    setOnButtonExitEvent (func) {
        this.uiMenu.setOnButtonExitEvent(func);
    }



    // вкл - когда кнопка soundOff отжимается
    setOnButtonSoundOnEvent (func) {
        this.uiMenu.setOnButtonSoundOnEvent(func);
    }

    // выкл - когда кнопка soundOn отжимается
    setOnButtonSoundOffEvent (func) {
        this.uiMenu.setOnButtonSoundOffEvent(func);
    }

    setSoundButtonState (isOn) {
        this.uiMenu.setSoundButtonState(isOn);
    }



    // вкл - когда кнопка buttonAutoOff отжимается
    setOnButtonAutoPlayOnEvent (func) {
        this.uiMenu.setOnButtonAutoPlayOnEvent(func);
    }

    // выкл - когда кнопка buttonAutoOn отжимается
    setOnButtonAutoPlayOffEvent (func) {
        this.uiMenu.setOnButtonAutoPlayOffEvent(func);
    }

    setAutoPlayButtonVisible (isVisible) {
        this.uiMenu.setAutoPlayButtonVisible(isVisible);
    }

    setAutoPlayButtonState (isOn) {
        this.uiMenu.setAutoPlayButtonState(isOn);
    }

    setAutoPlayButtonEnable (isEnable) {
        this.uiMenu.setAutoPlayButtonEnable(isEnable);
    }



    _lockButton(button, isLock) {
        button.enabled = !isLock;
        button.alpha = isLock ? 0.5 : 1.0;
    }

    setBetValues (arrBetsValue, precision, delimiter, minBet, maxBet, precisionCeil) {
        this.uiPanel.setBetValues(arrBetsValue, precision, delimiter, minBet, maxBet, precisionCeil);
    }
}



// WEBPACK FOOTER //
// ./src/uiscene.es6